// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ypdpxhmxswctunhkdpmh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlwZHB4aG14c3djdHVuaGtkcG1oIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU1OTA5NjAsImV4cCI6MjA2MTE2Njk2MH0.-n-VT17Te9tQFh9zLnyuSPIGlWWZgfh7knpMfmdeKZM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);